/*
  dn-search.js  -  Such-Drawer

  Drei Ergaenzungen zum Theme-Element predictive-search-drawer (theme.js):

  1. Die Abfrage beim Tippen fordert neben Produkten auch Kollektionen, Artikel
     und Suchbegriffe (Shopifys Vorschlaege) an und faengt Fehlerantworten ab.
     Vorher stand bei jeder Eingabe "undefined" im Drawer, weil die Section
     predictive-search fehlte und die Antwort (404) ungeprueft eingesetzt wurde.
  2. Vorschlags-Chips (data-dn-query) setzen den Begriff ins Suchfeld und suchen
     weiter, statt zur Suchseite zu springen.
  3. "Zuletzt angesehen" wird erst beim ersten Oeffnen des Drawers geladen
     (Section dn-search-recent ueber die Section Rendering API).

  Uebernommen aus dem US-Theme; zwei Ergaenzungen fuer dieses Theme:
  4. Das Theme dieses Stores fuehrt die Liste "Zuletzt angesehen" noch nicht
     selbst - auf Produktseiten merkt dieses Skript die Produkt-ID unter
     demselben Schluessel wie das US-Theme (theme:recently-viewed-products).
  5. Der Plus-Knopf der kompakten Karten legt die Variante in den Warenkorb -
     mit derselben Ereigniskette wie die Produktformulare des Themes
     (variant:added, cart:updated, cart:refresh), damit der Mini-Cart neu
     zeichnet, der Zaehler stimmt und theme.liquid den Such-Drawer schliesst
     und den Warenkorb oeffnet. Im US-Theme macht das dn-cart.js.
*/
(function () {
  var TYPEN = 'product,collection,article,query';

  /* Antworten je Begriff merken: Tippen und Loeschen fragt sonst denselben Begriff mehrfach an. Waehrend der
     Anfrage traegt die Trefferliste aria-busy, damit Screenreader den Wechsel einordnen koennen. */
  var gemerkt = {};
  customElements.whenDefined('predictive-search-drawer').then(function () {
    var proto = customElements.get('predictive-search-drawer').prototype;
    proto._doPredictiveSearch = async function (term) {
      var schluessel = String(term).trim().toLowerCase();
      if (gemerkt[schluessel]) return gemerkt[schluessel];
      var liste = this.querySelector('.predictive-search__results');
      if (liste) liste.setAttribute('aria-busy', 'true');
      try {
        var url = window.themeVariables.routes.predictiveSearchUrl
          + '?q=' + encodeURIComponent(term)
          + '&resources[type]=' + TYPEN
          + '&resources[options][unavailable_products]=show'
          + '&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search';
        var response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) {
          return { hasResults: false, html: '<div class="dn-sr dn-sr--leer"><p class="dn-sr__none">' + (window.dnSuchTexte && window.dnSuchTexte.keine || 'No results') + '</p></div>' };
        }
        var div = document.createElement('div');
        div.innerHTML = await response.text();
        var wrapper = div.firstElementChild;
        var ergebnis = {
          hasResults: div.querySelector('.predictive-search__results-categories') !== null,
          html: wrapper ? wrapper.innerHTML : ''
        };
        gemerkt[schluessel] = ergebnis;
        return ergebnis;
      } finally {
        if (liste) liste.removeAttribute('aria-busy');
      }
    };
  });

  function drawer() { return document.querySelector('predictive-search-drawer'); }

  /* 2. Vorschlags-Chips */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-dn-query]');
    if (!chip) return;
    var dr = chip.closest('predictive-search-drawer');
    if (!dr) return;
    var input = dr.querySelector('[name="q"]');
    if (!input) return;
    e.preventDefault();
    input.value = chip.getAttribute('data-dn-query');
    input.focus();
    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
  });

  /* 3. Zuletzt angesehen und Bilder - moeglichst bevor die Schublade offen ist.
     Gemessen: der Block kam ~300ms nach dem Oeffnen und schob die Bestseller um
     450px nach unten; die lazy-Bilder starteten erst mit der Sichtbarkeit.
     Deshalb: Platzhalter in Kartenhoehe sofort, Fetch und Bilder schon bei
     Beruehren/Hover/Fokus des Such-Icons ("Absicht"), spaetestens beim Oeffnen. */
  var KARTE_PX = 102;
  function bilderEager(wurzel) {
    wurzel.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  function skelett(n) {
    var html = '<h3 class="empty_item_heading dn-skel__kopf" aria-hidden="true">&nbsp;</h3><div class="dn-empty-best__list dn-sr__list">';
    for (var i = 0; i < n; i++) html += '<div class="dn-ups__card dn-skel" style="height:' + KARTE_PX + 'px" aria-hidden="true"></div>';
    return html + '</div>';
  }
  function zuletztEinsetzen(dr) {
    var ziel = dr.querySelector('[data-dn-recent]');
    if (!ziel || ziel.dataset.geladen) return;
    ziel.dataset.geladen = '1';
    var items = [];
    try { items = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]'); } catch (err) { items = []; }
    if (!items.length) return;
    var n = Math.min(items.length, 4);
    ziel.innerHTML = skelett(n);
    ziel.hidden = false;
    var q = items.slice(0, 4).map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = window.themeVariables.routes.searchUrl + '?type=product&q=' + encodeURIComponent(q) + '&section_id=dn-search-recent';
    fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var div = document.createElement('div');
      div.innerHTML = html;
      var inhalt = div.querySelector('recently-viewed-products');
      if (!html || !inhalt || !inhalt.children.length) { ziel.hidden = true; ziel.innerHTML = ''; return; }
      ziel.innerHTML = inhalt.innerHTML;
      bilderEager(ziel);
    }).catch(function () { ziel.hidden = true; ziel.innerHTML = ''; });
  }
  /* Bestseller-Karten des Leerzustands liegen als <template data-dn-spaeter> im HTML
     (snippets/predictive-search.liquid). Geschlossen kosteten sie auf jeder Seite ~500 Knoten,
     Produktkarten, 4-7 Flickity-Galerien und ~0,7 MB Bilder (gemessen 2026-09-23, 390px, CPU 4x:
     Long Task 300-500 ms nach load). Eingesetzt wird beim ersten Beruehren/Hover/Fokus des
     Such-Icons, spaetestens beim Oeffnen - eine Karte je Task, damit der Tipp aufs Icon nicht auf
     einen langen Block wartet. Bis Flickity steht, zeigt der Rohzustand nur das erste Bild
     (devify_css: .main_media_silder .product__media-list:not(.flickity-enabled)). */
  function kartenEinsetzen(dr) {
    dr.querySelectorAll('template[data-dn-spaeter]').forEach(function (vorlage) {
      var teile = Array.prototype.slice.call(vorlage.content.children);
      (function naechste() {
        var teil = teile.shift();
        if (teil) {
          var karte = document.importNode(teil, true);
          bilderEager(karte);
          vorlage.parentNode.insertBefore(karte, vorlage);
        }
        if (teile.length) setTimeout(naechste, 0); else vorlage.remove();
      })();
    });
  }
  function primen() {
    var dr = drawer();
    if (!dr || dr.dataset.dnGeprimt) return;
    dr.dataset.dnGeprimt = '1';
    kartenEinsetzen(dr);
    bilderEager(dr);
    zuletztEinsetzen(dr);
  }
  /* Fokus zurueck zum Ausloeser: das Theme laesst den Fokus beim Schliessen im unsichtbaren Drawer
     (gemessen 2026-09-09: activeElement blieb das Suchfeld). Tastatur- und Screenreader-Nutzer landen
     sonst im Nichts. Ausloeser ist der zuletzt geklickte Such-Schalter ausserhalb des Drawers. */
  var ausloeser = null;
  function fokusZurueck(dr) {
    var aktiv = document.activeElement;
    if (aktiv && aktiv !== document.body && !dr.contains(aktiv)) return;
    var ziel = (ausloeser && ausloeser.isConnected && !dr.contains(ausloeser)) ? ausloeser : null;
    if (!ziel) {
      ziel = Array.prototype.find.call(document.querySelectorAll('[aria-controls="search-drawer"]'), function (el) { return !dr.contains(el) && el.offsetParent !== null; }) || null;
    }
    if (ziel && ziel.focus) ziel.focus({ preventScroll: true });
  }
  function beobachten() {
    var dr = drawer();
    if (!dr) return;
    if (dr.hasAttribute('open')) primen();
    var warOffen = dr.hasAttribute('open');
    new MutationObserver(function () {
      var offen = dr.hasAttribute('open');
      if (offen) primen();
      if (warOffen && !offen) setTimeout(function () { fokusZurueck(dr); }, 50);
      warOffen = offen;
    }).observe(dr, { attributes: true, attributeFilter: ['open'] });
    document.querySelectorAll('[aria-controls="search-drawer"]').forEach(function (el) {
      ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
        el.addEventListener(ev, primen, { passive: true, once: true });
      });
      el.addEventListener('click', function () { if (!dr.contains(el)) ausloeser = el; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachten); else beobachten();

  /* 4. Zuletzt angesehen merken (Produkt-ID setzt snippets/predictive-search.liquid auf Produktseiten) */
  (function merken() {
    var id = window.dnSuchProdukt;
    if (!id) return;
    try {
      var liste = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
      liste = [id].concat(liste.filter(function (x) { return String(x) !== String(id); })).slice(0, 12);
      localStorage.setItem('theme:recently-viewed-products', JSON.stringify(liste));
    } catch (err) { /* Speicher gesperrt (privater Modus) - dann eben ohne Liste */ }
  })();

  /* 5. Plus-Knopf: wie das Produktformular des Themes (theme.js ProductForm) */
  var addLaeuft = false;
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('predictive-search-drawer .dn-ups__add[data-dn-add]');
    if (!knopf) return;
    e.preventDefault();
    if (addLaeuft) return;
    addLaeuft = true;
    knopf.classList.add('is-busy');
    var spinner = knopf.querySelector('.dn-ups__spinner');
    if (spinner) spinner.hidden = false;
    var routes = (window.themeVariables && window.themeVariables.routes) || {};
    var cartUrl = routes.cartUrl || '/cart';
    fetch(cartUrl + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(knopf.getAttribute('data-dn-add')), quantity: 1, sections: 'mini-cart' })
    })
      .then(function (r) { if (!r.ok) throw new Error('add.js ' + r.status); return r.json(); })
      .then(function (antwort) {
        /* vom Knopf aus, damit theme.liquid den Klick dem Such-Drawer zuordnet (closest('#search-drawer')) */
        knopf.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: antwort.items ? antwort.items[0] : antwort } }));
        return fetch(cartUrl + '.js').then(function (r) { return r.json(); }).then(function (warenkorb) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: warenkorb } }));
          warenkorb.sections = antwort.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: warenkorb } }));
        });
      })
      .catch(function (fehler) { console.error('Suche: Produkt konnte nicht in den Warenkorb', fehler); })
      .finally(function () {
        addLaeuft = false;
        knopf.classList.remove('is-busy');
        if (spinner) spinner.hidden = true;
      });
  });
})();
